<template>
  <!-- スクリーンサイズの非活性レイヤーを配置 -->  
  <Layer v-model="value">
    <!-- エディタサイズが大きいのでセンター固定にする。modal-content:b-popoverの親-->      
    <div class="cx_popup_editor_content modal-content" :style="{width:width + 'px', height:height + 'px', marginTop:offset + 'px', marginLeft:offset + 'px'}"  id="popupEditor">
         <!-- ヘッダにクローズボタンを配置 -->        
        <div class="cx_popup_editor_header">
           <div class="cx_popup_editor_title">
              <SvgIcon :name="svg" v-if="svg" :width="28" :height="28"/>          
              <span>{{title}}</span>
            </div>
            <button type="button" @click="onClose"><i class="material-icons small valign">close</i></button>
        </div>            
         <!-- ListViewコンポーネント配置用のスロット -->
         <div class="cx_popup_editor_body">
            <div class="spinner spinner_body" v-if="isLoading">
              <div class="spinner-border text-info" role="status"></div>
              <span>データを取得しています..</span>
            </div>              
             <slot :popup="_self"></slot>
        </div>
         <!-- リスト選択モードで使用する際のスロット -->
         <div class="modal-footer" v-if="$scopedSlots.buttons">
             <slot name="buttons"></slot>
        </div>        
    </div>
  </Layer>
</template>
<script lang="ts">
import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';

//ポップアップ上部にクローズボタンを配置する
//編集モードの場合、初期状態は読取～エディタ下部の編集ボタンで編集を開始
//新規モードの場合、エディタ下部のキャンセルボタンは配置しない。

@Component
export default class PopupEditor extends Vue {
  @Prop({ default: false }) public value : boolean;
  @Prop({ default: 1080 }) public width : number;
  @Prop({ default: 600 }) public height : number;
  @Prop({default:''}) public title : string;
  @Prop({ default: 'editor' }) public mode : string; //editor/list
  @Prop({ default: false}) public isInsertMode : boolean;

  public svg: string = null;
  public isLoading = true;
  public edittingItem:any = null;
  public offset = 0;

  @Watch('value')
  public onValueChanged(){
    if (this.value) {
      this.isLoading = true;

      var findPopup =(el:HTMLElement) : number =>{
          if (el == document.body) return 0;
          else return findPopup(el.parentElement)  +  (el.className.includes('cx_popup_editor_content') ? 1 : 0);
      };
      this.offset = findPopup(this.$el.parentElement) * 15;
    }
  }
  public onClose(){
    //closingイベントを送出(バリデーション用)

    var arg = {canceled:false, target:this.edittingItem};
    this.$emit('closing',arg);
    if (arg.canceled) return;

    //v-modelを更新する
    this.$emit('input',false);                
  }

}
</script>
<style lang="scss">
.cx_popup_editor_content{
    display: flex;
    background-color: white;
    width:100%;
    height:100%;        
    border-radius: 6px;
    flex-direction: column;

    .cx_popup_editor_header{
        display: flex;
        height: 40px;
        width:100%;
        justify-content: space-between;
        margin-top:6px;            
        border-bottom:1px solid #cccccc;
        .cx_popup_editor_title{
            display: flex;
            align-items: center;
            padding-left: 20px;          
          span {
              // margin-top : 10px;
              margin-left : 10px;
          }
        }

        button {
            outline: none;
            box-shadow: none;            
            border-width: 0px;      
            background-color: transparent;                
            margin-right: 5px;
        }
    }
    .cx_popup_editor_body{
        flex:1;
        width: 100%;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;            
        display: flex;
        flex-direction: column;
        overflow: hidden;
        background-color: rgb(247,247,247);             
        position: relative;
        .cx_listView_editor{
                background-color:white;                
        }
        .cx_tab_header{
                background-color:white;
        }

        //cx_editor下に設定された不要マージンの削除(Editorから呼び出されるためcx_editorがセットされてしまう)
        .cx_grid {
          margin-bottom: 0px;
        }
        .cx_editor .cx_grid {
          margin-bottom: 15px;
        }

        .cx_listView_content_left_header1{
          border-top: unset !important;
        }
    }
    .cx_popup_editor_footer{
      height: 55px;
      display:flex;
      justify-content: end;
      align-items: center;
      border-top: 1px solid #cccccc;
      .cx_button{
        font-size: 14px;
        height: 35px;        
      }
    }

    .cx_grid{
        //PopupEditrのグリッド表示崩れを修正
        .control_cell{
          padding-top: 5px;
          padding-left: 10px;
          padding-right: 10px;        
        }
    }    
}
  
  </style>